module.exports = "<article [style.textAlign]=\"align\" [innerHTML]=\"description\"></article>"